export default __webpack_public_path__ + "static/media/hero-3.82cae129.jpg";